export default __webpack_public_path__ + "static/media/graphic-11.3f6a8b4f.png";